import Router from "../..";
import { handleApiError } from "./indexApi";

const BASE_URL = process.env.REACT_APP_API_URL_PRO;

export const dashboardApi = {
  getNewCampaigns: async () => {
    try {
      const res = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/dashboard/get/new/campaign`,
        {
          headers: { authorization: localStorage.getItem("authorization") },
        }
      );

      return res.data?.result;
    } catch (err) {
      handleApiError(err, "새로운 캠페인 목록 조회에 실패했습니다.");
      return null;
    }
  },

  getPopularCampaigns: async () => {
    try {
      const res = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/dashboard/get/popular/campaign`,
        {
          headers: { authorization: localStorage.getItem("authorization") },
        }
      );
      return res.data?.result;
    } catch (err) {
      handleApiError(err, "인기 캠페인 목록 조회에 실패했습니다.");
      return null;
    }
  },

  getTrendingHashtags: async () => {
    try {
      const res = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/dashboard/get/popular/hashtag`,
        {
          headers: { authorization: localStorage.getItem("authorization") },
        }
      );
      return res.data?.result;
    } catch (err) {
      handleApiError(err, "인기 해시태그 목록 조회에 실패했습니다.");
      return null;
    }
  },

  getDailyTopCreators: async () => {
    try {
      const res = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/dashboard/get/top/viewed/influencers`,
        {
          headers: { authorization: localStorage.getItem("authorization") },
        }
      );
      return res.data?.result;
    } catch (err) {
      handleApiError(err, "일일 인기 크리에이터 조회에 실패했습니다.");
      return null;
    }
  },
};
